<template>
  <div class="wrap">
    <!-- 顶部 -->
    <div class="trendtop orangeToYellow">
      <div class="trendtop_left fs40 ellipsis">
        <p>识别结果</p>
      </div>
    </div>
    <div class="content">
      <div class="img_area">
        <img :src="imgUrl" alt="" />
      </div>
      <div class="ctn">
        <div class="box">
          <div class="title">
            <span class="bor"></span>
            识别结果（仅供参考）
          </div>
          <div class="info">
            <div class="left">{{ title }}</div>
            <div class="right">
              可信度
              <span class="core">{{ core }}</span>
            </div>
          </div>
        </div>

        <!-- <div class="box" style="margin-top: 25px;">
          <div class="title">
            <span class="bor"></span>
            防治方案
          </div>
        </div>
        <div class="list">
          <div class="list_item" v-for="(item, index) in list" :key="index">
            <div class="top">
              <img
                src="./../../../assets/images/book.png"
                alt=""
                width="18px"
                height="20px"
              />
              <div class="title">{{ item.title }}</div>
            </div>
            <div class="bor starBox">
              <span class="txt">实用指数</span>
              <span class="core">{{ item.core }}</span>
              <span class="star">
                <img
                  src="./../../../assets/images/star.png"
                  alt=""
                  v-for="(item, index) in 4"
                  :key="index"
                  width="16px"
                  height="16px"
                />
                <img
                  src="./../../../assets/images/star_grey.png"
                  alt=""
                  width="16px"
                  height="16px"
                />
              </span>
            </div>
            <div class="row">
              <div class="label">治疗</div>
              <div class="value">{{ item.treatment }}</div>
            </div>
            <div class="row">
              <div class="label">生产厂家</div>
              <div class="value">{{ item.manufactor }}</div>
            </div>
            <div class="row">
              <div class="label">有效成分</div>
              <div class="value">{{ item.ingredient }}</div>
            </div>
            <div class="row">
              <div class="label">特别提示</div>
              <div class="value">{{ item.tip }}</div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgUrl: '',
      core: '',
      title: '',
      list: [
        {
          title: '方案1:氯氟·噻虫胺(德立卡)',
          core: 4.2,
          treatment: '蚜虫',
          manufactor: '安道麦辉丰（江苏）有限公司',
          ingredient: '高效氯氟氰菊酯噻虫胺',
          tip: '注意防护',
        },
        {
          title: '方案2:高氯·啶虫眯(普击)',
          core: 4,
          treatment: '蚜虫',
          manufactor: '东莞市瑞德丰生物科技有限公司',
          ingredient: '啶虫眯高效氯氟菊酯',
          tip: '无',
        },
      ],

      imgs: [
        'https://api.ascod.cn/static-camera/20211209/20211209134121.jpg',
        'https://api.ascod.cn/static-camera/20211209/20211209134147.jpg',
        'https://api.ascod.cn/static-camera/20211209/20211209134130.jpg',
        'https://api.ascod.cn/static-camera/20211209/20211209134126.jpg',
        'https://api.ascod.cn/static-camera/20211209/20211209134137.jpg',
        'https://api.ascod.cn/static-camera/20211209/20211209134107.jpg',
        'https://api.ascod.cn/static-camera/20211209/20211209134142.jpg',
      ],
    }
  },

  mounted() {
    //  const reslut = {
    //     reslut: "柑橘木虱",
    //     core: 86.2,
    //     url: this.imgUrl
    //   };
    const { result, core, url } = JSON.parse(this.$route.params.result)
    this.imgUrl = url
    this.core = core
    this.title = result

    if (this.imgs.includes(url)) {
      this.core = 0.2
      this.title = '蚜虫'
    }

    const tList = []
    const fList = []

    this.list.map((item) => {
      let core = Math.round(item.core)
      let t = core
      let f = 5 - t
      console.log('123:', t, f)
      if (t) {
        for (let i = 0; i < t; i++) {
          tList.push(true)
        }
      }

      if (f) {
        for (let i = 0; i < f; i++) {
          fList.push(false)
        }
      }

      item.tList = tList
      item.fList = fList
    })

    console.log('this.list:', this.list)
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
.wrap {
  background: #f9f9fb;
}

.trendtop {
  height: 60px;
  overflow: hidden;
  line-height: 30px;
  padding: 15px 10px;
  width: 100%;
  box-sizing: border-box;
  z-index: 9999999999;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.3);
}
.trendtop .trendtop_left {
  float: left;
  color: #fff;
  padding: 0 0.4rem 0 0;
  position: relative;
  max-width: 3rem;
  font-size: 15px;
  font-weight: 700;
}

.img_area {
  margin: 15px;

  img {
    width: 100%;
  }
}

.ctn {
  margin: 24px 15px;
}

.box {
  .title {
    font-size: 16px;
    font-weight: bold;
    color: #14284a;
    margin-bottom: 15px;

    .bor {
      display: inline-block;
      width: 5px;
      height: 11px;
      background: #4171e5;
      margin-right: 10px;
    }
  }

  .info {
    display: flex;
    justify-content: space-between;
    background: #ffffff;
    box-shadow: 0px 5px 5px rgba(208, 199, 255, 0.06);
    border-radius: 5px;
    padding: 20px 15px;

    .left {
      font-size: 14px;
      font-weight: bold;
      color: #14284a;
    }

    .right {
      font-size: 14px;
      font-weight: 500;
      color: #14284a;

      span {
        font-size: 15px;
        font-weight: bold;
        color: #4171e5;
      }
    }
  }
}

.list {
  margin-top: 25px;

  .list_item {
    background: #ffffff;
    box-shadow: 0px 5px 5px rgba(208, 199, 255, 0.06);
    border-radius: 5px;
    margin-bottom: 15px;
    padding: 15px;
  }

  img {
    margin-right: 8px;
  }

  .top {
    display: flex;
    align-items: center;
  }

  .title {
    font-size: 18px;
    font-weight: bold;
    color: #14284a;
  }

  .core {
    font-size: 15px;
    font-weight: bold;
    color: #4171e5;
    border-top: 1px solid #f1f1f1;
  }

  .row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 45px;

    .label {
      font-size: 14px;
      font-weight: bold;
      color: #14284a;
    }

    .value {
      font-size: 14px;
      font-weight: 500;
      color: #14284a;
    }
  }
}

.starBox {
  display: flex;
  align-items: center;
  font-size: 14px;
  height: 45px;

  .txt {
    font-size: 14px;
    font-weight: 500;
    color: #14284a;
    margin-right: 10px;
  }

  .core {
    color: #4171e5;
    margin-right: 25px;
  }

  .star {
    display: flex;
    align-items: center;
    margin-bottom: 2px;
  }
}
</style>
